module.exports = __webpack_public_path__ + "static/img/8areaB_08.72bd9a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_08.png
// module id = 1237
// module chunks = 1